import { useState } from "react";
import { FaArrowRight, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();

    if (!validateInputs()) {
      return;
    }

    const templateParams = {
      from_name: name,
      message,
      email,
    };

    try {
      await emailjs.send(
        "service_3ino6hf",
        "template_9hts2eg",
        templateParams,
        "EsCiLTmAuitWPOFwR"
      );

      setName("");
      setEmail("");
      setMessage("");
      toast.success("Mensagem enviada com sucesso!");
    } catch (error) {
      console.error(error);
      toast.error("Não foi possível enviar a mensagem agora.");
    }
  }

  function validateInputs() {
    if (!name.trim() || !email.trim() || !message.trim()) {
      toast.error("Preencha todos os campos.");
      return false;
    }

    return true;
  }

  return (
    <section id="contato" className="bg-[#fbf8f3] py-24 text-slate-900">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-amber-700">
            Contato
          </p>
          <h2 className="mt-4 text-4xl font-semibold tracking-tight text-slate-950 sm:text-5xl">
            Vamos conversar sobre o seu caso
          </h2>
          <p className="mt-5 text-lg leading-8 text-slate-600">
            Se você precisa de orientação jurídica, podemos conversar por
            WhatsApp, e-mail ou formulário. O retorno é objetivo e direto.
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
          <aside className="rounded-[2rem] border border-amber-950/10 bg-white p-8 shadow-[0_18px_50px_rgba(15,23,42,0.06)]">
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-amber-700">
              Atendimento
            </p>
            <p className="mt-4 text-2xl font-semibold text-slate-950">
              Prioridade para clareza, discrição e agilidade.
            </p>
            <p className="mt-4 text-sm leading-7 text-slate-600">
              Cada contato é tratado com atenção para que você saiba como
              avançar sem ruído, sem excesso de formalidade e com visão prática.
            </p>

            <div className="mt-8 space-y-4">
              <a
                href="https://wa.me/message/7PUPDXBNVORFM1"
                className="flex items-center justify-between gap-4 rounded-2xl border border-amber-950/10 bg-[#faf6ef] px-4 py-4 transition hover:border-amber-500/40 hover:bg-white"
              >
                <span className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-emerald-400/15 text-emerald-600">
                    <FaWhatsapp />
                  </span>
                  <span>
                    <strong className="block text-sm text-slate-950">
                      WhatsApp
                    </strong>
                    <span className="text-sm text-slate-600">
                      Resposta rápida e prática
                    </span>
                  </span>
                </span>
                <FaArrowRight className="text-slate-400" />
              </a>

              <a
                href="mailto:contato@cleisson.adv.br"
                className="flex items-center justify-between gap-4 rounded-2xl border border-amber-950/10 bg-[#faf6ef] px-4 py-4 transition hover:border-amber-500/40 hover:bg-white"
              >
                <span className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-amber-400/15 text-amber-700">
                    <FaEnvelope />
                  </span>
                  <span>
                    <strong className="block text-sm text-slate-950">E-mail</strong>
                    <span className="text-sm text-slate-600">
                      contato@cleisson.adv.br
                    </span>
                  </span>
                </span>
                <FaArrowRight className="text-slate-400" />
              </a>

              <div className="flex items-center justify-between gap-4 rounded-2xl border border-amber-950/10 bg-[#faf6ef] px-4 py-4">
                <span className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-sky-400/15 text-sky-600">
                    <FaMapMarkerAlt />
                  </span>
                  <span>
                    <strong className="block text-sm text-slate-950">
                      Localização
                    </strong>
                    <span className="text-sm text-slate-600">
                      Rio Verde - GO e atendimento online
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </aside>

          <form
            onSubmit={handleSubmit}
            className="rounded-[2rem] border border-amber-950/10 bg-white p-6 text-slate-900 shadow-[0_20px_60px_rgba(15,23,42,0.08)] sm:p-8"
          >
            <div className="grid gap-4 sm:gap-5">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-semibold text-slate-600"
                >
                  Nome
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                  placeholder="Seu nome completo"
                  autoComplete="name"
                  className="mt-2 h-12 w-full rounded-2xl border border-slate-200 bg-[#faf8f5] px-4 text-base text-slate-900 outline-none transition focus:border-amber-500 focus:bg-white focus:ring-4 focus:ring-amber-500/10 sm:h-14"
                />
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-semibold text-slate-600"
                >
                  E-mail
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="seuemail@exemplo.com"
                  autoComplete="email"
                  className="mt-2 h-12 w-full rounded-2xl border border-slate-200 bg-[#faf8f5] px-4 text-base text-slate-900 outline-none transition focus:border-amber-500 focus:bg-white focus:ring-4 focus:ring-amber-500/10 sm:h-14"
                />
              </div>

              <div>
                <label
                  htmlFor="message"
                  className="block text-sm font-semibold text-slate-600"
                >
                  Mensagem
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={message}
                  onChange={(event) => setMessage(event.target.value)}
                  placeholder="Conte brevemente qual é a sua demanda"
                  rows="4"
                  className="mt-2 w-full rounded-2xl border border-slate-200 bg-[#faf8f5] px-4 py-3 text-base text-slate-900 outline-none transition focus:border-amber-500 focus:bg-white focus:ring-4 focus:ring-amber-500/10 sm:py-4 sm:rows-6"
                />
              </div>

              <button
                type="submit"
                className="inline-flex w-full items-center justify-center gap-3 rounded-full bg-slate-950 px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 bg-amber-700 hover:bg-amber-600 sm:w-auto"
              >
                Enviar mensagem
                <FaArrowRight />
              </button>

              <p className="text-sm leading-6 text-slate-500">
                Sua mensagem será analisada com atenção. Se preferir, use o
                botão do WhatsApp para um contato mais rápido.
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
